import React from 'react';
import { useLocation } from 'react-router-dom';

const MobileNavigator = ({ cartItems = [] }) => {
  const { pathname } = useLocation();
  const cartCount = cartItems.length || 0;

  const handleNavigation = (url) => {
    window.location.href = url; // forces reload
  };

  return (
    <div className="mobile-footer-nav">
      <div
        className={`nav-item ${pathname === '/' ? 'active' : ''}`}
        onClick={() => handleNavigation('/')}
      >
        <i className="fas fa-home"></i>
        <span>Home</span>
      </div>

      <div
        className={`nav-item ${pathname === '/shop' ? 'active' : ''}`}
        onClick={() => handleNavigation('/shop')}
      >
        <i className="fas fa-shop"></i>
        <span>Shop</span>
      </div>

      <div
        className={`nav-item ${pathname === '/login' ? 'active' : ''}`}
        onClick={() => handleNavigation('/login')}
      >
        <i className="fas fa-user"></i>
        <span>Profile</span>
      </div>

      <div
        className={`nav-item ${pathname === '/cart' ? 'active' : ''}`}
        onClick={() => handleNavigation('/cart')}
      >
        <div className="icon-badge-wrapper">
          <i className="fas fa-shopping-cart"></i>
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </div>
        <span>Cart</span>
      </div>
    </div>
  );
};

export default MobileNavigator;
